export default class MessagesUtils {
  public static getMessage(messages: any, key: string, ...args: any): string {
    let message: string = messages[key];
    if (!message) return '';
    if (args && args.length > 0) {
      for (let i = 0; i < args.length; i++) {
        message = message.replace(`{${i}}`, args[i]);
        do {
          message = message.replace(`{${i}}`, args[i]);
        } while (message.includes(`{${i}}`));
      }
    }
    return message;
  }
}
